import Vue from 'vue'
import Vuex from 'vuex'
import biddingPreload from './modules/biddingPreload'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: { biddingPreload }
})
